import React from 'react';
import ReactDOM from 'react-dom/client';
import { disableConsoleInProduction } from './utils/logger';

// Desabilitar console.log em produção para segurança
if (process.env.NODE_ENV === 'production') {
  disableConsoleInProduction();
}
import './index.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';
import './config/axios'; // Configurar axios

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// Request notification permission
if ('Notification' in window) {
  Notification.requestPermission();
}

// Forçar tema claro no HTML
document.documentElement.classList.remove('dark');
document.documentElement.style.colorScheme = 'light';

// Disable React.StrictMode temporarily to avoid double rendering issues
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
